module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/RatingCard/images/union_no_position.fb4e07bd.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/RatingCard/images/union_no_position.png
// module id = 3460
// module chunks = 11